import IconActions from '../../../../shared/components/IconActions';
import React from 'react';
import { Eye, EyeOff } from '../../../../shared/assets/AppIcons';
import PrimaryActionButton from '../../../../shared/components/patterns/PrimaryActionButton';

function PasswordField({ id, label, value, visible, onChange, onToggle, placeholder, disabled = false }) {
  return (
    <label className="settings-field" htmlFor={id}>
      <span>{label}</span>
      <div className="settings-password-field">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          className="settings-input settings-input--with-action"
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
        />
        <button
          type="button"
          onClick={onToggle}
          disabled={disabled}
          className="settings-password-field__toggle"
          aria-label={visible ? 'Nascondi password' : 'Mostra password'}
        >
          {visible ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
    </label>
  );
}

export default function PasswordSettingsCard({
  security,
  status = {},
  isEditing,
  onOpenEdit,
  onCancel,
  onConfirm,
  onFieldChange,
  onToggleVisibility,
}) {
  return (
    <section className="settings-card">
      <header className="settings-card__header">
        <h2 className="settings-card__title">Password</h2>
        <p className="settings-card__description">Modifica la tua password per mantenere l'account sicuro</p>
      </header>
      <div className="settings-card__body">
        {isEditing ? (
          <div className="settings-form-grid settings-form-grid--security">
            <PasswordField
              id="currentPassword"
              label="Password Attuale"
              value={security.currentPassword}
              visible={security.showCurrentPassword}
              onChange={(value) => onFieldChange('currentPassword', value)}
              onToggle={() => onToggleVisibility('showCurrentPassword')}
              placeholder="Inserisci password attuale"
              disabled={status.isSubmitting}
            />
            <PasswordField
              id="newPassword"
              label="Nuova Password"
              value={security.newPassword}
              visible={security.showNewPassword}
              onChange={(value) => onFieldChange('newPassword', value)}
              onToggle={() => onToggleVisibility('showNewPassword')}
              placeholder="Minimo 8 caratteri"
              disabled={status.isSubmitting}
            />
            <PasswordField
              id="confirmPassword"
              label="Conferma Nuova Password"
              value={security.confirmPassword}
              visible={security.showConfirmPassword}
              onChange={(value) => onFieldChange('confirmPassword', value)}
              onToggle={() => onToggleVisibility('showConfirmPassword')}
              placeholder="Ripeti la nuova password"
              disabled={status.isSubmitting}
            />
          </div>
        ) : null}
        {status.error ? (
          <div role="alert" className="settings-alert settings-alert--error wt-inline-error">
            {status.error}
          </div>
        ) : null}
        {status.success ? (
          <div className="settings-alert settings-alert--success">
            {status.success}
          </div>
        ) : null}
        <div className="settings-actions"><IconActions>
          {!isEditing ? (
            <PrimaryActionButton onClick={onOpenEdit} iconKey="actions.key">
              Cambia Password
            </PrimaryActionButton>
          ) : (
            <>
              <PrimaryActionButton onClick={onConfirm} disabled={status.isSubmitting} iconKey="actions.save">
                {status.isSubmitting ? 'Aggiornamento...' : 'Aggiorna Password'}
              </PrimaryActionButton>
              <button type="button" className="settings-secondary-button" onClick={onCancel} disabled={status.isSubmitting}>
                Annulla
              </button>
            </>
          )}
        </IconActions></div>
      </div>
    </section>
  );
}
